/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Kirill Vizniuk - kirill@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {FieldSet, FormulaType} from './fieldset';
import { SearchableItem } from './interface/searchable.item';
import { SearchableSelectionType } from './interface/searchable.selection';

export class Template implements SearchableItem {
  ID: string;
  NAME: string;
  FIELD_SET: FieldSet;
  FIELDS: TemplateValue[];

  // Helper
  FIELD_SET_ID: string;
  active: boolean;
  allowed = false;


  static parse(json: any): Template {
    if (json && typeof json === 'object') {
      const c = new Template();

      c.ID = json.ID;
      c.NAME = json.NAME;
      c.FIELD_SET = FieldSet.parse(json.FIELD_SET);

      if (json.FIELDS)
        c.FIELDS = TemplateValue.parseArray(json.FIELDS);

      return c;
    } else return null;
  }

  static parseArray(json: any[]): Template[] {
    const arr = [];

    if (json)
      for (const j of json)
        if (j)
          arr.push(Template.parse(j));

    return arr;
  }

  getName(): string {
    return `${this.NAME} of ${this.FIELD_SET.DISPLAY_NAME}`;
  }

  getFullDetails(): string {
    return `${this.NAME} of ${this.FIELD_SET.DISPLAY_NAME}`;
  }

  getValue(): any {
    return this;
  }
  getType(): SearchableSelectionType {
    return SearchableSelectionType.VALUE;
  }
}

// Field used to set Values into Template
export class TemplateValue {
  ID: string;
  FIELD: string;
  DISPLAY_NAME?: string;
  FORMAT: TemplateFieldFormat;
  FORMAT_VALUE: string;
  SHEET: string;
  CELL: string;
  SOURCE_CELL: string;
  FORMULA: FormulaType;
  ORDER_BY: string;
  LIMIT: number;
  OVERFLOW_SHEET:string;
  OVERFLOW_CELL:string;
  ORDER_DIRECTION: OrderDirectiton;
  ORDER_BY_SEC: string;
  ORDER_DIRECTION_SEC: OrderDirectiton;

  static parse(json: any): TemplateValue {
    if (json && typeof json === 'object') {
      const c = new TemplateValue();

      c.ID = json.ID;
      c.FIELD = json.FIELD;

      c.FORMAT = TemplateFieldFormat[<string>json.FORMAT];
      c.FORMAT_VALUE = json.FORMAT_VALUE;

      c.SHEET = json.SHEET;
      c.CELL = json.CELL;
      c.FORMULA = FormulaType[<string>json.FORMULA];
      c.ORDER_BY = json.ORDER_BY;
      c.SOURCE_CELL = json.SOURCE_CELL;
      c.LIMIT = json.LIMIT;
      c.OVERFLOW_SHEET = json.OVERFLOW_SHEET;
      c.OVERFLOW_CELL = json.OVERFLOW_CELL;
      c.ORDER_DIRECTION = OrderDirectiton[<string>json.ORDER_DIRECTION];
      c.ORDER_BY_SEC = json.ORDER_BY_SEC;
      c.ORDER_DIRECTION_SEC = OrderDirectiton[<string>json.ORDER_DIRECTION_SEC];

      return c;
    } else return null;
  }

  static parseArray(json: any[]): TemplateValue[] {
    const arr = [];

    if (json)
      for (const j of json)
        if (j)
          arr.push(TemplateValue.parse(j));

    return arr;
  }
}

export enum TemplateFieldFormat {
  TEXT = 'TEXT',
  NUMBER = 'NUMBER',
  DATE = 'DATE',
  DATE_FORMATTED = 'DATE_FORMATTED',
  DATE_TIME = 'DATE_TIME',
  TIME = 'TIME',
  COMMA_SEPARATED = 'COMMA_SEPARATED'
}

export enum OrderDirectiton {
  ASC = 'ASC',
  DESC = 'DESC'
}
